import styled from 'styled-components'

export const ErrorText = styled.span`
  color: ${p => p.theme.palette.negative};
`
